import { Component, OnInit, ElementRef, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';

import { PortsSearchService } from './ports-search.service';
import { LogService, Port } from './../../shared';
declare const moment: any;

@Component({
  selector: 'ports-search',
  template: require('./ports-search.component.html'),
  styles: [require('./ports-search.component.scss')],
  providers: [PortsSearchService],
  host: {
    '(document:click)': 'onClick($event)'
  }
})
export class PortsSearchComponent implements OnInit {
  @Output() close: EventEmitter<any> = new EventEmitter();

  private searchTermStream: Subject<any> = new Subject<any>();
  searchTerm: string = '';
  item: Port = null;
  date: string;

  itemsSub: any;
  items = Array<Port>();

  constructor(private logger: LogService, private router: Router, private service: PortsSearchService) {
    // Do stuff
  }

  ngOnInit() {
    this.logger.log('ports-search.component', 'ngOnInit', 'Hello Ports Search');
    this.initSearchBox();

    this.loadCache();
  }

  initSearchBox() {
    this.itemsSub = this.searchTermStream
      .debounceTime(100)
      .distinctUntilChanged()
      .switchMap((term: string) => this.service.getPorts(term)).subscribe((ports: Array<Port>) => {
        this.items = ports;
      });
  }

  loadCache() {
    if (sessionStorage.getItem('ports-search-term')) {
      this.searchTerm = sessionStorage.getItem('ports-search-term')
    }
    if (sessionStorage.getItem('ports-search-date')) {
      this.date = sessionStorage.getItem('ports-search-date');
    }
  }

  onClick($event: any) {
    if ($event.target.id === 'searchbox' && !this.service.autoOn) {
      this.auto();
    } else if ($event.target.id !== 'searchbox' && this.service.autoOn) {
      this.service.autoOn = false;
    }
  }

  search() {
    let date = moment(this.date, 'YYYY-MM-DD').format('YYYY-MM-DD');
    if (this.item !== null) {
      this.close.emit({ event: event, searchType: '', location: 'header' });
      this.router.navigate(['/ports', this.item.id, { date: encodeURIComponent(this.date) }]);
    } else if (sessionStorage.getItem('ports-search-item-id')) {
      var portId = +sessionStorage.getItem('ports-search-item-id');
      this.close.emit({ event: event, searchType: '', location: 'header' });
      this.router.navigate(['/ports', portId, { date: encodeURIComponent(this.date) }]);
    }

    sessionStorage.setItem('ports-search-term', this.searchTerm);
    sessionStorage.setItem('ports-search-date', this.date);
    sessionStorage.setItem('ports-search-item-id', this.item.id.toString());
  }

  set(item: Port) {
    this.service.autoOn = false;
    this.logger.log('ports-search', 'set', item);
    this.searchTerm = item.title;
    this.item = item;
  }

  auto(event: KeyboardEvent = null) {
    this.logger.log('ports-search', 'auto', this.service.noResult);
    if (event != null) {
      this.capture(event.keyCode);
    }

    if (this.searchTerm.length < 3) {
      if (this.service.app.carriers.length === 0) {
        this.service.autoOn = false;
      } else {
        this.service.autoOn = true;
      }
    } else {
      if (this.service.autoOn === false) {
        this.service.startSearch();
      }
      this.searchTermStream.next(this.searchTerm);
      this.logger.log('ports-search', 'auto else', this.service.autoOn);
    }
  }

  selectText($event) {
    $event.target.select();
  }

  capture(keyCode: number) {
    switch (keyCode) {
      case 9:
        this.autocomplete();
        break;
      case 13:
        this.autocomplete();
        this.search();
        break;
      case 35:
        this.highlight('up');
        break;
      case 40:
        this.highlight('down');
        break;
    }
  }

  autocomplete() {
    try {
      if (this.items != null && this.items.length != 0) {
        this.set(this.items[0]);
        this.service.autoOn = false;
      }
    } catch (ex) {
      this.logger.log('ports-search', 'autocomplete ex', ex);
    }
  }

  highlight(direction: string = 'down') {
    if (this.items == null || this.items.length == 0) {
      return;
    }

    // expand to highlight items in the list
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/search/ports-search/ports-search.component.ts